module.exports = __webpack_public_path__ + "static/img/headtextbg.5203f96.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/dawan/headtextbg.png
// module id = 708
// module chunks = 0